














































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import moment from "moment";
import VCDateTimePicker from "@/components/form_components/VCDateTimePicker.vue";
import UnitRuangPicker from "@/components/common/UnitRuangPicker.vue";
import SerahTerimaDarahDialog from "@/components/bank-darah/SerahTerimaDarahDialog.vue";
import OrderBankDarahSvc from "@/services/OrderBankDarah";
import { appModule } from "@/store/modules/app";
import {
  DaftarPasienBankDarahRow,
  DaftarPasienOrder,
  DaftarPasienStatus,
  STATUS_WARNA
} from "@/types/order_bank_darah";
import { composeDate, toDateString } from "@/utils/asesmenIntensifDateTime";
import { cocokCariPasien } from "@/utils/cariPasienBankDarah";
import { bukaPemeriksaanBankDarah } from "@/utils/bukaPemeriksaanBankDarah";

const STATUS_MENUNGGU_SERAH_TERIMA = ["diterima", "menunggu_sampel"];
const STATUS_SIAP_HASIL = ["dikerjakan", "selesai"];
const STATUS_BISA_BATAL = ["diterima", "menunggu_sampel", "dikerjakan", "selesai"];

@Component({ components: { VCDateTimePicker, UnitRuangPicker, SerahTerimaDarahDialog } })
export default class CardDaftarPasienBankDarah extends Vue {
  loading = false;
  showFilter = false;
  search: string | null = null;
  rows: DaftarPasienBankDarahRow[] = [];

  filter: {
    tgl_start: string;
    tgl_end: string;
    unit_id: string | null;
    status: DaftarPasienStatus | "";
  } = {
    tgl_start: moment().format("YYYY-MM-DD"),
    tgl_end: moment().format("YYYY-MM-DD"),
    unit_id: null,
    status: ""
  };

  pilih: DaftarPasienBankDarahRow | null = null;
  dialogPersetujuan = false;
  dialogSerahTerimaBelum = false;
  dialogSerahTerima = false;
  orderSerahTerima: DaftarPasienOrder | null = null;
  dialogBatal = false;
  orderBatal: DaftarPasienOrder | null = null;
  alasanBatal = "";
  membatalkan = false;
  membukaRegister: string | null = null;

  readonly statusItems = [
    { text: "Semua", value: "" },
    { text: "Diproses", value: "diproses" },
    { text: "Selesai", value: "selesai" },
    { text: "Dibatalkan", value: "dibatalkan" }
  ];

  readonly headers = [
    { text: "Pasien", value: "pasien", sortable: false, width: "15%" },
    { text: "Indikator", value: "indikator", sortable: false, width: "6%" },
    { text: "Alamat", value: "pasien.alamat", sortable: false, width: "13%" },
    { text: "Register", value: "register_id", width: "9%" },
    { text: "No Order", value: "orders", sortable: false, width: "17%" },
    { text: "DPJP / Jaminan", value: "dokter", sortable: false, width: "13%" },
    { text: "Ruang / Kelas / TT", value: "unit", sortable: false, width: "12%" },
    { text: "Status", value: "status", width: "7%" },
    { text: "Aksi", value: "aksi", sortable: false, align: "end", width: "8%" }
  ];

  get rowsTampil(): DaftarPasienBankDarahRow[] {
    return this.rows.filter(r =>
      cocokCariPasien(this.search, [r.pasien.rm, r.pasien_rm, r.pasien.nama, r.register_id])
    );
  }

  get persetujuanKurang(): string[] {
    if (!this.pilih) return [];
    const daftar: string[] = [];
    this.orderSiapHasil(this.pilih).forEach(o => {
      (o.persetujuan_kurang || []).forEach(label => {
        if (daftar.indexOf(label) < 0) daftar.push(label);
      });
    });
    return daftar;
  }

  get tglStartDate(): Date | null {
    return composeDate(this.filter.tgl_start);
  }
  set tglStartDate(val: Date | null) {
    this.filter.tgl_start = toDateString(val) || this.filter.tgl_start;
  }

  get tglEndDate(): Date | null {
    return composeDate(this.filter.tgl_end);
  }
  set tglEndDate(val: Date | null) {
    this.filter.tgl_end = toDateString(val) || this.filter.tgl_end;
  }

  mounted() {
    this.muat();
  }

  async muat() {
    this.loading = true;
    try {
      this.rows = await OrderBankDarahSvc.daftarPasien(this.filter);
    } catch {
      return;
    } finally {
      this.loading = false;
    }
  }

  setelahBerubah() {
    this.muat();
    this.$emit("changed");
  }

  warnaStatus(status: string): string {
    return STATUS_WARNA[status] || "blue-grey";
  }

  warnaStatusPasien(status: DaftarPasienStatus): string {
    return { diproses: "indigo", selesai: "green", dibatalkan: "grey" }[status] || "blue-grey";
  }

  tanggal(val: string | null): string {
    return val ? moment(val, "YYYY-MM-DD").format("DD-MM-YYYY") : "-";
  }

  orderBelumSerahTerima(item: DaftarPasienBankDarahRow): DaftarPasienOrder[] {
    return item.orders.filter(o => STATUS_MENUNGGU_SERAH_TERIMA.indexOf(o.status) >= 0);
  }

  orderSiapHasil(item: DaftarPasienBankDarahRow): DaftarPasienOrder[] {
    return item.orders.filter(o => STATUS_SIAP_HASIL.indexOf(o.status) >= 0);
  }

  orderBisaDibatalkan(item: DaftarPasienBankDarahRow): DaftarPasienOrder[] {
    return item.orders.filter(o => STATUS_BISA_BATAL.indexOf(o.status) >= 0);
  }

  bisaInputHasil(item: DaftarPasienBankDarahRow): boolean {
    return item.orders.some(o => o.status !== "dibatalkan");
  }

  async bukaPemeriksaan(registerId: string) {
    this.membukaRegister = String(registerId);
    try {
      await bukaPemeriksaanBankDarah(this.$router, registerId);
    } finally {
      this.membukaRegister = null;
    }
  }

  inputHasil(item: DaftarPasienBankDarahRow) {
    if (!this.bisaInputHasil(item)) return;
    this.pilih = item;

    if (this.orderBelumSerahTerima(item).length) {
      this.dialogSerahTerimaBelum = true;
      return;
    }

    this.lanjutSetelahSerahTerima();
  }

  lanjutSetelahSerahTerima() {
    this.dialogSerahTerimaBelum = false;
    if (!this.pilih) return;

    if (this.persetujuanKurang.length) {
      this.dialogPersetujuan = true;
      return;
    }

    this.bukaHalamanHasil();
  }

  bukaHalamanHasil() {
    this.dialogPersetujuan = false;
    if (!this.pilih) return;

    const siap = this.orderSiapHasil(this.pilih);
    const utama = siap.find(o => o.status === "dikerjakan") || siap[0];

    this.$router.push({
      name: "bank-darah-hasil",
      query: {
        rm: this.pilih.pasien_rm,
        register: String(this.pilih.register_id),
        nama: this.pilih.pasien.nama || "",
        ...(utama ? { jenis: utama.jenis } : {})
      }
    });
  }

  isiSerahTerima(o: DaftarPasienOrder) {
    this.dialogSerahTerimaBelum = false;
    this.orderSerahTerima = o;
    this.dialogSerahTerima = true;
  }

  bukaBatal(item: DaftarPasienBankDarahRow, o: DaftarPasienOrder) {
    if (!o.bisa_batal) return;
    this.pilih = item;
    this.orderBatal = o;
    this.alasanBatal = "";
    this.dialogBatal = true;
  }

  async batal() {
    if (!this.orderBatal || !this.alasanBatal.trim()) return;

    this.membatalkan = true;
    try {
      const res = await OrderBankDarahSvc.batal(
        this.orderBatal.sumber,
        this.orderBatal.id,
        this.alasanBatal.trim()
      );
      appModule.sendSuccessNotice(res.message);
      this.dialogBatal = false;
      this.setelahBerubah();
    } catch {
      return;
    } finally {
      this.membatalkan = false;
    }
  }
}
